// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scaleUpVerTop {
    -webkit-animation: scaleUpVerTop 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    animation: scaleUpVerTop 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

@-webkit-keyframes scaleUpVerTop {
    0% {
        opacity: 0;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0;
    }
    100% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1);
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0;
        opacity: 1;
    }
}
@keyframes scaleUpVerTop {
    0% {
        opacity: 0;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0;
    }
    100% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1);
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0;
        opacity: 1;
    }
}


.bounceIn {
    opacity: 0;
    animation-name: bounceIn;
    animation-duration: 450ms;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}

@keyframes bounceIn{
    0%{
        opacity: 0;
        transform: scale(0.3) translate3d(0,0,0);
    }
    50%{
        opacity: 0.9;
        transform: scale(1.1);
    }
    80%{
        opacity: 1;
        transform: scale(0.89);
    }
    100%{
        opacity: 1;
        transform: scale(1) translate3d(0,0,0);
    }
}

.fadeIn {
    opacity: 0;
    animation-name: fadeIn;
    animation-duration: 450ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
}

.fadeInFast {
    opacity: 0;
    animation-name: fadeIn;
    animation-duration: 100ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.fadeOut {
    opacity: 1;
    animation-name: fadeOut;
    animation-duration: 450ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 0;
    }
}

.slideInTop {
  opacity: 0;
  animation-name: slideInTop;
  animation-duration: 450ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

@keyframes slideInTop {
  0%{
      opacity: 0;
      transform: translateY(-600px);
  }
  50%{
      opacity: 0.5;
      transform: translateY(-300px);
  }
  100%{
      opacity: 1;
      transform: translateY(0);
  }
}

.slideInRight {
    opacity: 0;
    animation-name: slideInRight;
    animation-duration: 450ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
}

@keyframes slideInRight {
    0%{
        opacity: 0;
        transform: translateX(150%);
    }
    100%{
        opacity: 1;
        transform: translateX(0);
    }
}

.slideOutRight {
    opacity: 1;
    animation-name: slideOutRight;
    animation-duration: 450ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
}

@keyframes slideOutRight {
    0%{
        opacity: 1;
        transform: translateX(0);
    }
    100%{
        opacity: 0;
        transform: translateX(150%);
    }
}

/* CSS from https://codepen.io/nzbin/pen/GGrXbp */

.dot-pulse {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #e0e0e0;
    color: #e0e0e0;
    box-shadow: 9999px 0 0 -5px #e0e0e0;
    animation: dotPulse 1.5s infinite linear;
    animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #e0e0e0;
    color: #e0e0e0;
}

.dot-pulse::before {
    box-shadow: 9984px 0 0 -5px #e0e0e0;
    animation: dotPulseBefore 1.5s infinite linear;
    animation-delay: 0s;
}

.dot-pulse::after {
    box-shadow: 10014px 0 0 -5px #e0e0e0;
    animation: dotPulseAfter 1.5s infinite linear;
    animation-delay: .5s;
}

@keyframes dotPulseBefore {
    0% {
        box-shadow: 9984px 0 0 -5px #e0e0e0;
    }
    30% {
        box-shadow: 9984px 0 0 2px #e0e0e0;
    }
    60%,
    100% {
        box-shadow: 9984px 0 0 -5px #e0e0e0;
    }
}

@keyframes dotPulse {
    0% {
        box-shadow: 9999px 0 0 -5px #e0e0e0;
    }
    30% {
        box-shadow: 9999px 0 0 2px #e0e0e0;
    }
    60%,
    100% {
        box-shadow: 9999px 0 0 -5px #e0e0e0;
    }
}

@keyframes dotPulseAfter {
    0% {
        box-shadow: 10014px 0 0 -5px #e0e0e0;
    }
    30% {
        box-shadow: 10014px 0 0 2px #e0e0e0;
    }
    60%,
    100% {
        box-shadow: 10014px 0 0 -5px #e0e0e0;
    }
}

.loader {
    width: 18px;
    height: 18px;
    border: 2px solid #000;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

.loader.white {
    border-color: white;
    border-bottom-color: transparent;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.skeleton {
    animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
    0% {
        background-color: hsl(200, 20%, 80%);
    }
    100% {
        background-color: hsl(200, 20%, 95%);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/style/animation.css"],"names":[],"mappings":"AAAA;IACI,mFAAmF;IACnF,2EAA2E;AAC/E;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;QAC5B,oBAAoB;QACpB,gCAAgC;QAChC,wBAAwB;IAC5B;IACA;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,gCAAgC;QAChC,wBAAwB;QACxB,UAAU;IACd;AACJ;AACA;IACI;QACI,UAAU;QACV,4BAA4B;QAC5B,oBAAoB;QACpB,gCAAgC;QAChC,wBAAwB;IAC5B;IACA;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,gCAAgC;QAChC,wBAAwB;QACxB,UAAU;IACd;AACJ;;;AAGA;IACI,UAAU;IACV,wBAAwB;IACxB,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;QACV,wCAAwC;IAC5C;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,sCAAsC;IAC1C;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE;MACI,UAAU;MACV,6BAA6B;EACjC;EACA;MACI,YAAY;MACZ,6BAA6B;EACjC;EACA;MACI,UAAU;MACV,wBAAwB;EAC5B;AACF;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,yBAAyB;IACzB,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,yBAAyB;IACzB,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ;;AAEA,iDAAiD;;AAEjD;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,mCAAmC;IACnC,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,kCAAkC;IACtC;IACA;;QAEI,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,kCAAkC;IACtC;IACA;;QAEI,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;IACA;QACI,mCAAmC;IACvC;IACA;;QAEI,oCAAoC;IACxC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI;QACI,oCAAoC;IACxC;IACA;QACI,oCAAoC;IACxC;AACJ","sourcesContent":[".scaleUpVerTop {\n    -webkit-animation: scaleUpVerTop 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    animation: scaleUpVerTop 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n}\n\n@-webkit-keyframes scaleUpVerTop {\n    0% {\n        opacity: 0;\n        -webkit-transform: scaleY(0);\n        transform: scaleY(0);\n        -webkit-transform-origin: 100% 0;\n        transform-origin: 100% 0;\n    }\n    100% {\n        -webkit-transform: scaleY(1);\n        transform: scaleY(1);\n        -webkit-transform-origin: 100% 0;\n        transform-origin: 100% 0;\n        opacity: 1;\n    }\n}\n@keyframes scaleUpVerTop {\n    0% {\n        opacity: 0;\n        -webkit-transform: scaleY(0);\n        transform: scaleY(0);\n        -webkit-transform-origin: 100% 0;\n        transform-origin: 100% 0;\n    }\n    100% {\n        -webkit-transform: scaleY(1);\n        transform: scaleY(1);\n        -webkit-transform-origin: 100% 0;\n        transform-origin: 100% 0;\n        opacity: 1;\n    }\n}\n\n\n.bounceIn {\n    opacity: 0;\n    animation-name: bounceIn;\n    animation-duration: 450ms;\n    animation-timing-function: linear;\n    animation-fill-mode: forwards;\n}\n\n@keyframes bounceIn{\n    0%{\n        opacity: 0;\n        transform: scale(0.3) translate3d(0,0,0);\n    }\n    50%{\n        opacity: 0.9;\n        transform: scale(1.1);\n    }\n    80%{\n        opacity: 1;\n        transform: scale(0.89);\n    }\n    100%{\n        opacity: 1;\n        transform: scale(1) translate3d(0,0,0);\n    }\n}\n\n.fadeIn {\n    opacity: 0;\n    animation-name: fadeIn;\n    animation-duration: 450ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n.fadeInFast {\n    opacity: 0;\n    animation-name: fadeIn;\n    animation-duration: 100ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n.fadeOut {\n    opacity: 1;\n    animation-name: fadeOut;\n    animation-duration: 450ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.5;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.slideInTop {\n  opacity: 0;\n  animation-name: slideInTop;\n  animation-duration: 450ms;\n  animation-timing-function: ease-in-out;\n  animation-fill-mode: forwards;\n}\n\n@keyframes slideInTop {\n  0%{\n      opacity: 0;\n      transform: translateY(-600px);\n  }\n  50%{\n      opacity: 0.5;\n      transform: translateY(-300px);\n  }\n  100%{\n      opacity: 1;\n      transform: translateY(0);\n  }\n}\n\n.slideInRight {\n    opacity: 0;\n    animation-name: slideInRight;\n    animation-duration: 450ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n@keyframes slideInRight {\n    0%{\n        opacity: 0;\n        transform: translateX(150%);\n    }\n    100%{\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.slideOutRight {\n    opacity: 1;\n    animation-name: slideOutRight;\n    animation-duration: 450ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n@keyframes slideOutRight {\n    0%{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    100%{\n        opacity: 0;\n        transform: translateX(150%);\n    }\n}\n\n/* CSS from https://codepen.io/nzbin/pen/GGrXbp */\n\n.dot-pulse {\n    position: relative;\n    left: -9999px;\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: #e0e0e0;\n    color: #e0e0e0;\n    box-shadow: 9999px 0 0 -5px #e0e0e0;\n    animation: dotPulse 1.5s infinite linear;\n    animation-delay: .25s;\n}\n\n.dot-pulse::before, .dot-pulse::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: #e0e0e0;\n    color: #e0e0e0;\n}\n\n.dot-pulse::before {\n    box-shadow: 9984px 0 0 -5px #e0e0e0;\n    animation: dotPulseBefore 1.5s infinite linear;\n    animation-delay: 0s;\n}\n\n.dot-pulse::after {\n    box-shadow: 10014px 0 0 -5px #e0e0e0;\n    animation: dotPulseAfter 1.5s infinite linear;\n    animation-delay: .5s;\n}\n\n@keyframes dotPulseBefore {\n    0% {\n        box-shadow: 9984px 0 0 -5px #e0e0e0;\n    }\n    30% {\n        box-shadow: 9984px 0 0 2px #e0e0e0;\n    }\n    60%,\n    100% {\n        box-shadow: 9984px 0 0 -5px #e0e0e0;\n    }\n}\n\n@keyframes dotPulse {\n    0% {\n        box-shadow: 9999px 0 0 -5px #e0e0e0;\n    }\n    30% {\n        box-shadow: 9999px 0 0 2px #e0e0e0;\n    }\n    60%,\n    100% {\n        box-shadow: 9999px 0 0 -5px #e0e0e0;\n    }\n}\n\n@keyframes dotPulseAfter {\n    0% {\n        box-shadow: 10014px 0 0 -5px #e0e0e0;\n    }\n    30% {\n        box-shadow: 10014px 0 0 2px #e0e0e0;\n    }\n    60%,\n    100% {\n        box-shadow: 10014px 0 0 -5px #e0e0e0;\n    }\n}\n\n.loader {\n    width: 18px;\n    height: 18px;\n    border: 2px solid #000;\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n}\n\n.loader.white {\n    border-color: white;\n    border-bottom-color: transparent;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.skeleton {\n    animation: skeleton-loading 1s linear infinite alternate;\n}\n\n@keyframes skeleton-loading {\n    0% {\n        background-color: hsl(200, 20%, 80%);\n    }\n    100% {\n        background-color: hsl(200, 20%, 95%);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
